import styled from 'styled-components';

export const TotalsLine = styled.div`
  display: flex;
  flex-direction: row;
`;

const Totals = styled.p<{ bold?: boolean }>`
  text-align: right;
  font-weight: 400;
  ${(props) => props.bold && 'font-weight: 800;'}
  padding: 5px 10px 5px 0;
  margin: 0;
`;

export const TotalsLeft = styled(Totals)`
  width: 70%;
`;

export const TotalsRight = styled(Totals)`
  width: 30%;
`;
